export default __webpack_public_path__ + "static/media/loading.c6306382.svg";